module.exports = __webpack_public_path__ + "img/referate.530ca2cf.svg";